const CategoryLimit = {
    GENERAL: '1',
    FOOD: '2',
    TRAVEL: '3'
}
export default CategoryLimit